import ViewProfilForm from "../../components/views/profile/oper/dodajProfil/ViewProfilForm.jsx";
import ViewListaKontProfilu from "../../components/views/profile/wp/listaKontProfilu/ViewListaKontProfilu.jsx";

export const profileRoutes = [

    {
        path: `/wp/profile/konta/:profilId`,
        exact: true,
        roles: [`owner`],
        forbidden: true,
        view: <ViewListaKontProfilu />,
        mode: `any`,
    },
    {
        path: `/wp/profile/:tryb/:id`,
        exact: true,
        roles: [`any`],
        forbidden: true,
        view: <ViewProfilForm />,
        mode: `pass`,
    },
]
